export const AUTH_RC = {
  root: 'auth',
  children: {
    root: '',
    logIn: 'login',
    resetPassword: 'reset-password',
    forgotPassword: 'forgot-password',
  },
};

export const AUTHORIZED_RC = {
  root: '',
  children: {
    orderManagement: 'order-management',
    messages: 'messages',
    users: 'users',
  },
};

export const ROOT_ONLY_ROUTES = ['/order-management', '/messages', '/users'];
